import { render, staticRenderFns } from "./AddMatchButton.vue?vue&type=template&id=5f04de82&"
import script from "./AddMatchButton.vue?vue&type=script&lang=js&"
export * from "./AddMatchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports